var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'box-loading': _vm.loading}},[(_vm.notFind)?_c('div',{staticClass:"alert alert-warning"},[_vm._v("\n    Nenhum workflow encontrado\n    ")]):_vm._e(),_vm._v(" "),_c('Approvalflow',{attrs:{"approvalflowId":_vm.approvalflowId},on:{"redefined":_vm.redefinedApprovalflow}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-458d4060","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Requisition/RequisitionApprovalflow.vue
// module id = null
// module chunks = 